import useUpdateCalendarDay from '../../../hooks/useUpdateCalendarDay';

function PeriodDayToggle({ ipData, date, isFutureDate, setMessage }) {
  const { updateCalendarDay } = useUpdateCalendarDay();
  const isPeriodDay = ipData?.periodDay ?? false;

  const handleToggle = () => {
    if (isFutureDate) {
      setMessage({ type: 'alert', text: 'Cannot select for future date' });
      return;
    }
    setMessage(null);
    updateCalendarDay(date, 'periodDay', !isPeriodDay);
  };

  return (
    <button
      onClick={handleToggle}
      className={`flex flex-col items-center gap-1 rounded-xl border p-3 text-xs transition-colors ${
        isPeriodDay ? 'border-destructive bg-baby-pink text-destructive' : 'border-border hover:border-destructive/50'
      }`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/></svg>
      Period day
    </button>
  );
}

export default PeriodDayToggle;
